// src/hooks/useOptionalLocationSearch.js
//
// Current URL query string, reactive to router navigation when rendered inside
// a Router, and falling back to window.location when rendered without one
// (several lead-detail table components are unit-tested and embedded without a
// Router). The hook call is unconditional, so hook order is stable.
import { useLocation } from 'react-router-dom';

export default function useOptionalLocationSearch() {
  try {
    return useLocation().search || '';
  } catch {
    return typeof window !== 'undefined' ? window.location.search || '' : '';
  }
}
